module.exports = __webpack_public_path__ + "static/media/download.75c635a9.svg";